import { useEffect, useState } from "react";
import {
    useMutation
} from "react-query";
import { httpGET, httpPUT } from "../../utils/ajaxHelper";
import AGButton from "../Button";

import { FieldArray, Formik, FormikProps } from "formik";
import { useContext, useRef } from "react";
import {
    Address,
    AgnetRegion,
    ComMainService,
    CommerceFirmDatumRes,
    CompracticeLevel,
    FirmAddress,
    Individual,
} from "../../models";
import AGSelect from "../AgSelect";

import { UserContext } from "../../Provider";
import {
    CommerceCompassStyled,
    CustomBackground
} from "./modalUpdateService.styled";

import isEqual from "lodash/isEqual";

import moment from "moment";
import { CommerceUpdateProductSchema } from "../../Schema/CommerceCompassSchema";
import Button from "../Button";
import AGCheckbox from "../Checkbox";
import AGInput from "../Input";
import AGModal from "../Modal";
import { GlobalStyle, StyledDatePickerCus } from "../ModalAddService/modalAddService.styled";
import { useNotification } from "../Notification";
import { RolesHandle, RolesHandleAdmin } from "../RolesHandle";
import { default as AGTextarea, default as AGtextarea } from "../Textarea";
import Tooltip from "../Tooltip";
import { ADMIN_ORGANIZATION, MODAL_CONSTANT } from "../../utils/constant";
import { AddIconDatePicker } from "../AddIconDatePicker";
import { useSearchParams } from "react-router-dom";
import { handleNumericDateInput } from "../../utils/helper";

export interface UpdateProductModalProps {
    visible: boolean;
    toggleModal: () => void;
    toggleError: () => void;
    id: string;
    publishComplete: () => void;
    onDeleteService?: (e: boolean) => void;
    initSearchParams?: any;
    onEditSuccess?: (rs: any) => void;
}
const UpdateProductModal = ({
    visible,
    toggleModal,
    toggleError,
    id,
    publishComplete: publicComplete,
    onDeleteService,
    initSearchParams,
    onEditSuccess
}: UpdateProductModalProps) => {

    const handleClose = () => {
        toggleModal();
    };
    const handleErrorClose = () => {
        toggleError();
    };
    const { showNotification } = useNotification();
    const [submitCount, setSubmitCount] = useState<number>(0);
    const [firmData, setFirmData] = useState<CommerceFirmDatumRes | undefined>();
    const [agnetRegion, setAgnetRegion] = useState<AgnetRegion[]>();
    const [addAgnetRegion, setAddAgnetRegion] = useState<AgnetRegion[]>();
    const [firmAddresses, setFirmAddresses] = useState<Address[]>();
    const [comMainService, setComMainService] = useState<ComMainService[]>();
    const [individual, setIndividual] = useState<Individual[]>();
    const formRef = useRef<FormikProps<any>>(null);
    const componentRef = useRef<HTMLDivElement>(null);
    const user = useContext(UserContext);
    const [selectedDate, setSelectedDate] = useState(undefined);
    const [searchParams, setSearchParams] = useSearchParams();
    const [isDataChanged,setIsDataChanged] = useState<boolean>(false);

    const [compracticeLevel, setCompracticeLevel] =
        useState<CompracticeLevel[]>();
    const [submitType, setSubmitType] = useState<"Draff" | "Publish" | undefined>(undefined);

    const { mutate: getAgnetRegion } = useMutation(
        (firmId: number | undefined) =>
            httpGET({
                url: "/agnetregion",
                params: { firmId: firmId },
            }),
        {
            onSuccess: (rs) => {
                setAgnetRegion(rs as AgnetRegion[]);
            },
        },
    );

    const { mutate: getAddEditAgnetRegion } = useMutation(
        (firmId: number | undefined) =>
            httpGET({
                url: "/agnetregion/add-edit",
                params: { firmId: firmId },
            }),
        {
            onSuccess: (rs) => {
                setAddAgnetRegion(rs as AgnetRegion[]);
            },
        },
    );

    const { mutate: initData } = useMutation(
        (id: string) =>
            httpGET({
                url: `/CommerceFirmData/product/${id}`,
            }),
        {
            onSuccess: (rs) => {
                setFirmData(rs as CommerceFirmDatumRes);
            },
        },
    );

    const { mutate: getIndividuals } = useMutation(
        (id: any) =>
            httpGET({
                url: "/Individuals",
                params: { id },
            }),
        {
            onSuccess: (rs) => {
                setIndividual(rs as Individual[]);
            },
        },
    );

    const { mutate: getCompracticeLevel } = useMutation(
        () =>
            httpGET({
                url: "/compracticeLevel",
            }),
        {
            onSuccess: (rs) => {
                setCompracticeLevel(rs as CompracticeLevel[]);
            },
        },
    );

    const { mutate: getComMainServices } = useMutation(
        () =>
            httpGET({
                url: "/ComMainService",
                params: { type: "PRODUCT" }
            }),
        {
            onSuccess: (rs) => {
                setComMainService(rs as ComMainService[]);
            },
        },
    );

    const { mutate: getFirmAddresses } = useMutation(
        (id: any) =>
            httpGET({
                url: "/firm/firm-addresses",
                params: { id },
            }),
        {
            onSuccess: (rs) => {
                setFirmAddresses(rs as FirmAddress[]);
            },
        },
    );
    const { mutate: submitForm } = useMutation(
        (data: FormData) =>
            httpPUT({
                url: "/CommerceFirmData/product",
                data: data,
            }),
        {
            onSuccess: (rs) => {
                formRef.current?.resetForm();
                if (onEditSuccess){
                    onEditSuccess(rs);
                }
                setSubmitCount(0);
                if (firmData?.commerceFirmData?.isDraff) {
                    publicComplete();
                } else {
                    handleClose();
                }
            },
            onError: (rs: any) => {
                showNotification(rs.message, "Error");
                if (rs.message.includes("delete")) {
                    setSearchParams({ ...searchParams, tab: "product", serviceId: "" });
                    handleErrorClose();
                }else{
                    handleClose();
                }
            }
        },
    );

    useEffect(() => {
        if (visible) {
            initData(id);
            setSearchParams(initSearchParams);
        } else {
            setFirmData(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, visible])

    useEffect(() => {
        if (id && !firmData) {
            getAgnetRegion(user?.individual.fkOrgId);
            getAddEditAgnetRegion(user?.individual.fkOrgId);;
            getComMainServices();
            getCompracticeLevel();
        }
        if (firmData?.commerceFirmData) {
            getFirmAddresses(firmData?.commerceFirmData.region);
            getIndividuals(firmData?.firmName?.orgId);
        }


        /**
         * Will remove after checking on Monday
         * - Re-render Component continuously
         */
        // if (!visible && firmData) {
        //     setFirmData(undefined);
        // }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getAgnetRegion,
        getAgnetRegion,
        getComMainServices,
        getCompracticeLevel,
        getFirmAddresses,
        getIndividuals,
        visible,
        firmData,
    ]);

    useEffect(() => {
        if (submitType !== undefined) {
            formRef.current?.submitForm();
            setSubmitCount(submitCount + 1);
            setSubmitType(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [submitType]);

    // useEffect(() => {
    //     if (expertiseServices?.length > 0) {
    //         const limitation = +(process.env.REACT_APP_LIMIT || 5);
    //         const canNotSubmit = expertiseServices?.length >= limitation;
    //         if (canNotSubmit) {
    //             alert(
    //                 `Your organization has up to ${limitation} commerce compasses already.`,
    //             );
    //             navigate("/");
    //         }
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [expertiseServices]);

    if (!agnetRegion) {
        return null;
    }

    if (
        !firmData ||
        !agnetRegion ||
        !comMainService ||
        !firmAddresses ||
        !compracticeLevel
    ) {
        return null;
    }
    const initialValues = {
        mainServiceId: {
            label: firmData.tblComMainService?.mainServiceName,
            value: firmData.tblComMainService?.mainServiceId
        },
        firmId: firmData?.firmName?.orgId,
        acceptingClients: firmData?.commerceFirmData?.acceptingClients,
        willingOfferAdvice: firmData?.commerceFirmData?.willingOfferAdvice,
        loanStaff: firmData?.commerceFirmData?.loanStaff,
        receiveStaff: firmData?.commerceFirmData?.receiveStaff,
        title: firmData?.commerceFirmData?.title,
        country: {
            value: firmAddresses?.findIndex(
                (e) => e.fkOrgId === firmData?.firmName?.orgId,
            ),
            label:
                firmAddresses?.find(
                    (e) => e.fkOrgId === firmData?.firmName?.orgId,
                )?.firmName1 +
                " - " +
                firmAddresses?.find(
                    (e) => e.fkOrgId === firmData?.firmName?.orgId,
                )?.country,
            firmId: firmData?.firmName?.orgId,
        },
        keyContact: firmData?.individual?.map((e: any) => {
            return {
                value: e.individualId,
                label:
                    e.firstName +
                    " " +
                    e.lastName,
            };
        }).sort((a,b) => a.label.localeCompare(b.label)),
        highLevelPitch: firmData?.commerceFirmData?.highLevelPitch,
        compracticeLevels: firmData.comOfferingProductSecondaryService?.map(e => {

            return {
                compracticeLevel: "",
                secondaryServiceId: {
                    value: e.fkSecondaryServiceId,
                    label: comMainService.find(f => f.mainServiceId === firmData.tblComMainService?.mainServiceId)
                        ?.comOfferingSecondaryServices?.find(f => f.secondaryServiceId === e.fkSecondaryServiceId)?.secondaryServiceName
                }
            };
        }),
        locationServices: firmData.comOfferingLocationsServedVMs
            ?.map(e => {
                return {
                    netRegionId: {
                        value: e.fkNetRegionId,
                        label: addAgnetRegion!.find(f => f.netRegionId === e.fkNetRegionId)?.netRegionName
                    },
                    individualId: e.fkIndividualIds.map(f => {

                        const extIndividual = individual?.find(k => k.individualId === f)
                        return {
                            value: f,
                            label: extIndividual?.firstName +
                                " " +
                                extIndividual?.lastName
                        }
                    }).sort((a,b) => a.label.localeCompare(b.label))
                }
            }),
        compracticeLevelsCustom: firmData?.distinctPractice?.map((e: any) => {
            return {
                customName: e.areaOfExp,
                compracticeLevel: {
                    label: compracticeLevel?.find(
                        (f) => f.practiceLevelId === e.fkPracticeLevel,
                    )?.levelName,
                    value: compracticeLevel?.find(
                        (f) => f.practiceLevelId === e.fkPracticeLevel,
                    )?.practiceLevelId,
                },
            };
        }),
        urlLink: firmData?.commerceFirmData?.urlLink ?? "",
        webpageDisplayName: firmData?.commerceFirmData?.webpageDisplayName ?? "",
        videoLink: firmData?.commerceFirmData?.videoLink,
        tagLine: firmData?.commerceFirmData?.tagLine,
        detailedDescription: firmData?.commerceFirmData?.detailedDescription,
        // mainServiceId: firmData?.tblComMainService?.mainServiceId,
        region: {
            value: agnetRegion?.find(
                (e) => e.netRegionId === firmData?.commerceFirmData?.region,
            )?.netRegionId,
            label: agnetRegion?.find(
                (e) => e.netRegionId === firmData?.commerceFirmData?.region,
            )?.netRegionName,
        },
        comrelevantIndustry: firmData?.comrelevantIndustry?.industryName,
        globalOpportunities: firmData?.commerceFirmData?.globalOpportunities,
        filePdf: {
            name: firmData.comOfferingPdfFile?.pdfDisplayName
                ? firmData.comOfferingPdfFile?.pdfDisplayName
                : undefined,
        },
        isDeletePdf: false,
        memberBenefits: firmData.commerceFirmData?.memberBenefits ?? "",
        endDate: firmData.commerceFirmData?.sponsorEndDate
            ? new Date(firmData.commerceFirmData.sponsorEndDate)
            : null,
        startDate: firmData.commerceFirmData?.sponsorStartDate
            ? new Date(firmData.commerceFirmData.sponsorStartDate)
            : null,
        sponsorProfile: firmData.commerceFirmData?.sponsorProfile,
        sponsorMessage: firmData.commerceFirmData?.sponsorMessage ?? "",
        isDeleteServiceLogo: false,
        offerorLogoUrl: firmData.commerceFirmData?.offerorLogoUrl,
        serviceLogo: {
            name: firmData.commerceFirmData?.offerorLogoUrl
                ? firmData.commerceFirmData?.offerorLogoUrl?.split('?')[1]
                : undefined,
        },
    };

    if (!visible || !firmData || !individual) {
        return null;
    }

    return (
        <AGModal
            toggleModal={() => {
                toggleModal();
                formRef.current?.resetForm();
                setSubmitCount(0);
                setIsDataChanged(!isDataChanged)
            }}
            title="Edit Product"
            footer={
                <div className="flex justify-between w-full">
                    <AGButton
                        onClick={() => {
                            onDeleteService && onDeleteService(true);
                        }}
                        style={{ minWidth: "128px" }}
                        type="Danger">
                        Delete Product
                    </AGButton>

                    <AGButton
                        type="Success"
                        onClick={() => {
                            setSubmitType("Publish")
                        }}
                        disabled={!isDataChanged}
                    >
                        Publish
                    </AGButton>
                </div>
            }
            visible={visible}
            toolstip={true}
            titleTooltip={MODAL_CONSTANT.EDIT_PRODUCT}
        >
            <CustomBackground ref={componentRef}>
                <CommerceCompassStyled>
                    <div className="print">
                        <div>
                            <Formik
                                innerRef={formRef}
                                validationSchema={CommerceUpdateProductSchema}
                                initialValues={initialValues}
                                validateOnChange={submitCount >= 1}
                                onSubmit={(values) => {
                                    if (submitType !== undefined) {
                                        const data = {
                                            comFirmDataId: id,
                                            fkFirmId: values.firmId,
                                            dateEntered: moment(
                                                values.today,
                                            ).toISOString(),
                                            detailedDescription: values.detailedDescription.trim(),
                                            urlLink: values.urlLink ? values.urlLink.trim() : "",
                                            webpageDisplayName: values.webpageDisplayName ?? "",
                                            region: values.region.value,
                                            videoLink: values.videoLink ? values.videoLink.trim() : "",
                                            startDate: values.startDate && values.sponsorProfile ? values.startDate.toLocaleDateString("en-US") : "",
                                            endDate: values.startDate && values.sponsorProfile ? values.endDate.toLocaleDateString("en-US") : "",
                                            sponsorMessage: values.sponsorMessage ? values.sponsorMessage.trim() : "",
                                            sponsorProfile: values.sponsorProfile,
                                            memberBenefits: values.memberBenefits.trim() ?? "",
                                            isDeleteServiceLogo: values.isDeleteServiceLogo,
                                            isDeletePdf: values.isDeletePdf,
                                            comContactIds: values.keyContact.map(
                                                (e: any) => e.value,
                                            ),
                                            title: values.title.trim() ?? "",
                                            tagLine: values.tagLine.trim() ?? "",
                                            distinctPractices:
                                                values.compracticeLevelsCustom ? values.compracticeLevelsCustom
                                                    .filter((f: any) => f)
                                                    .filter(
                                                        (f: any) =>
                                                            f.customName &&
                                                            f.compracticeLevel,
                                                    )
                                                    .map((e: any) => {
                                                        return `${e.customName}___${e.compracticeLevel.value}`;
                                                    }) : [],
                                            compracticeLevels:
                                                values.compracticeLevels
                                                    .map((e: any) => {
                                                        return `${e?.secondaryServiceId.value}`;
                                                    }),
                                            locationServices:
                                                values.locationServices ? values.locationServices
                                                    .filter((f: any) => f)
                                                    .filter(
                                                        (f: any) => f.netRegionId && f.individualId
                                                    )
                                                    .map((e: any) => {
                                                        return `${e?.netRegionId.value}___${e?.individualId.filter((e: any) => e?.value !== '').map((f: any) => f.value).join(",")}`;
                                                    }) : [],

                                            globalOpportunities:
                                                values.globalOpportunities,
                                        } as any;
                                        const formData = new FormData();

                                        if (values.file) {
                                            formData.append("logo", values.file);
                                        }
                                        if (values.filePdf) {
                                            formData.append(
                                                "filePdf",
                                                values.filePdf,
                                            );
                                        }
                                        if (values.serviceLogo) {
                                            formData.append(
                                                "serviceLogo",
                                                values.serviceLogo,
                                            );
                                        }
                                        for (const key in data) {
                                            const value = data[key];

                                            if (Array.isArray(value)) {
                                                value.forEach((item: any) => {
                                                    formData.append(
                                                        `${key}`,
                                                        JSON.stringify(item),
                                                    );
                                                });
                                            } else {
                                                formData.append(key, value);
                                            }
                                        }

                                        if (submitType === 'Draff') {
                                            formData.append("isDraff", JSON.stringify(true));
                                            submitForm(formData);
                                        }
                                        if (submitType === 'Publish') {
                                            formData.append("isDraff", JSON.stringify(false));
                                            submitForm(formData);
                                        }
                                    }
                                }}
                            >
                                {({
                                    values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    dirty,
                                }) => {

                                    const filterEmptyValue = values.locationServices.filter((e : any) => e.individualId !== "" || e.netRegionId !== "");
                                    const isLocationServiceEqual = JSON.stringify(filterEmptyValue) === JSON.stringify(initialValues!.locationServices);

                                    const filterExterpriseEmptyValue = values.compracticeLevels.filter((e : any) => e.compracticeLevel !== "" || e.secondaryServiceId !== "");
                                    const isExterpriseEqual = JSON.stringify(filterExterpriseEmptyValue) === JSON.stringify(initialValues!.compracticeLevels);

                                    if( !values.serviceLogo){
                                        values.serviceLogo = { name: undefined }
                                    }

                                    if( !values.filePdf){
                                        values.filePdf = { name: undefined }
                                    }

                                    const isDirty = !isEqual(
                                        { ...values, 
                                            compracticeLevels: filterExterpriseEmptyValue,
                                            locationServices: filterEmptyValue,
                                            serviceLogo: values.serviceLogo
                                        },
                                        initialValues
                                    );

                                    setIsDataChanged(isDirty);
                                    
                                    if (firmData.commerceFirmData?.isDraff) {
                                        setIsDataChanged(true);
                                    }

                                    const optionInitialComSecondaryServices = values.mainServiceId ? comMainService?.find(
                                        (e) => e.mainServiceId === values.mainServiceId.value
                                    )?.comOfferingSecondaryServices?.map(
                                        (e) => ({
                                            value: e.secondaryServiceId,
                                            label: e.secondaryServiceName
                                        })) : [];
                                    const tblComSecondaryServices = values.mainServiceId ? comMainService?.find(
                                        (e) => e.mainServiceId === values.mainServiceId.value
                                    )?.comOfferingSecondaryServices?.map(
                                        (e) => ({
                                            value: e.secondaryServiceId,
                                            label: e.secondaryServiceName
                                        })).filter(e => !values.compracticeLevels.some((f: any) => f.secondaryServiceId?.value === e.value)) : [];

                                    let messengeError = "";
                                    Object.keys(errors).forEach(function (
                                        key,
                                        index,
                                    ) {
                                        if (
                                            key ===
                                            "compracticeLevelsCustom"
                                        ) {
                                            const compracticeLevelsCustom: any =
                                                errors[key];

                                            return (messengeError +=
                                                compracticeLevelsCustom.find(
                                                    (f: any) => f?.isValid,
                                                )
                                                    ? "Question 7" +
                                                    (index ===
                                                        Object.keys(errors)
                                                            .length -
                                                        1
                                                        ? "."
                                                        : ", ")
                                                    : "");
                                        }

                                        return (messengeError +=
                                            errors[key]
                                                ?.toString()
                                                .replace("_", "")
                                                .replace("+", "") +
                                            (index ===
                                                Object.keys(errors).length - 1
                                                ? "."
                                                : ", "));
                                    });
                                    return (
                                        <form>
                                            <RolesHandle firmId={ADMIN_ORGANIZATION.ID} roles={["Admin"]}>
                                                <div>
                                                    <label
                                                        className="label-title"
                                                        htmlFor="">
                                                        Organization Region:{" "}
                                                        <span className="required">
                                                            *
                                                        </span>
                                                    </label>
                                                    <div className="subtitle">
                                                        <span>
                                                            Please select the
                                                            Region.
                                                        </span>
                                                    </div>
                                                    <div className="custom-select">
                                                        <AGSelect
                                                            isDisabled
                                                            placeholder="Enter/ Select your answer"
                                                            value={
                                                                values.region
                                                            }
                                                            onChange={(
                                                                e: any,
                                                            ) => {
                                                                getFirmAddresses(
                                                                    e?.value as any,
                                                                );
                                                                setFieldValue(
                                                                    "country",
                                                                    "",
                                                                );
                                                                setFieldValue(
                                                                    "keyContact",
                                                                    "",
                                                                );
                                                                setFieldValue(
                                                                    "region",
                                                                    e,
                                                                );
                                                            }}
                                                            options={agnetRegion?.map(
                                                                (e) => {
                                                                    return {
                                                                        value: e.netRegionId,
                                                                        label: e.netRegionName,
                                                                    };
                                                                },
                                                            )}
                                                        />
                                                        {errors.region && (
                                                            <div className="error">
                                                                This question is
                                                                required.{" "}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                                <div>
                                                    <label
                                                        className="label-title"
                                                        htmlFor="">
                                                        Organization Name - Country:{" "}
                                                        <span className="required">
                                                            *
                                                        </span>
                                                    </label>
                                                    <div className="subtitle">
                                                        <span>
                                                            Please Select Organization (Country).
                                                        </span>
                                                    </div>
                                                    <AGSelect
                                                        isDisabled
                                                        placeholder="Enter/ Select your answer"
                                                        value={
                                                            values.country
                                                        }
                                                        onChange={(
                                                            e: any,
                                                        ) => {
                                                            getIndividuals(
                                                                e?.firmId as any,
                                                            );
                                                            setFieldValue(
                                                                "firmId", e?.firmId,
                                                            );
                                                            setFieldValue(
                                                                "keyContact",
                                                                "",
                                                            );
                                                            setFieldValue(
                                                                "country",
                                                                e,
                                                            );
                                                        }}
                                                        options={firmAddresses?.map(
                                                            (
                                                                e,
                                                                index,
                                                            ) => {
                                                                return {
                                                                    value: index,
                                                                    label:
                                                                        e.firmName1 +
                                                                        " - " +
                                                                        e.country,
                                                                    firmId: e.fkOrgId,
                                                                };
                                                            },
                                                        )}
                                                    />
                                                    {errors.country && (
                                                        <div className="error">
                                                            This
                                                            question is
                                                            required.{" "}
                                                        </div>
                                                    )}
                                                </div>
                                            </RolesHandle>
                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Key Contact(s):{" "}<span className="required">{" "}*</span>
                                                </label>
                                                <div data-tip="Tooltip content" className="subtitle">
                                                    Select a maximum of 3 key contacts. If a key contact for your organization isn’t listed, ask your organization’s AG Champion to get them added to our database.
                                                </div>
                                                <AGSelect
                                                    placeholder="Enter/ Select your answer"
                                                    value={
                                                        values.keyContact
                                                    }
                                                    onChange={(
                                                        e: any,
                                                    ) => {
                                                        if (e.length > 3) {
                                                            setFieldValue(
                                                                "keyContact",
                                                                e.slice(
                                                                    1,
                                                                    4,
                                                                ),
                                                            );
                                                        } else {
                                                            setFieldValue(
                                                                "keyContact",
                                                                e,
                                                            );
                                                        }
                                                    }}
                                                    options={individual?.sort((a, b) => ((a.firstName +
                                                        " " + a.lastName) > (b.firstName + " " + b.lastName)) ? 1
                                                        : ((b.firstName + " " +
                                                            b.lastName) > (a.firstName +
                                                                " " +
                                                                a.lastName) ? -1 : 0))
                                                        .map(
                                                            (e) => {
                                                                return {
                                                                    value: e.individualId,
                                                                    label: e.firstName + " " + e.lastName,
                                                                };
                                                            },
                                                        )}
                                                    isMulti
                                                />
                                                {errors.keyContact && (
                                                    <div className="error">
                                                        This question is required.
                                                    </div>
                                                )}
                                            </div>

                                            <FieldArray
                                                name="locationServices"
                                                render={(arrayHelpers) => (
                                                    <div>
                                                        <label
                                                            style={{
                                                                width: "100%",
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "start"
                                                            }}
                                                            className="label-title"
                                                            htmlFor="">
                                                            <div className="wraptitle">
                                                                Region Contact(s):
                                                                <Tooltip text={<div className="tool-tip">
                                                                    Key contacts are required, but if there are region-specific contacts for better connectivity, please list them here (optional).
                                                                </div>
                                                                } />
                                                            </div>
                                                        </label>

                                                        <div data-tip="Tooltip content" className="subtitle flex">
                                                            Select a maximum of 3 key contacts for each region. If a key contact for your organization isn’t listed, ask your organization’s AG Champion to get them added to our database.
                                                            <AGButton
                                                                type="Link"
                                                                icon={<PlusIcon />}
                                                                onClick={() =>
                                                                    arrayHelpers.push(
                                                                        {
                                                                            netRegionId: "",
                                                                            individualId: "",
                                                                        },
                                                                    )
                                                                }
                                                                disabled={addAgnetRegion ? values.locationServices.length >= addAgnetRegion?.length : true}
                                                            >
                                                                <div className="add-new">Add new</div>
                                                            </AGButton>
                                                        </div>
                                                        {individual && values.locationServices && values.locationServices.map((e: any, index: number,) => (
                                                            <div
                                                                className="w-full flex mb-[15px]"
                                                                key={index}>
                                                                <div className="w-[25%]">
                                                                    <AGSelect
                                                                        placeholder="Choose region"
                                                                        value={values.locationServices[index].netRegionId}
                                                                        onChange={(f: any) => {
                                                                            setFieldValue(`locationServices.${index}.netRegionId`, f);
                                                                        }}
                                                                        options={addAgnetRegion?.filter(f =>
                                                                            f.netRegionId &&
                                                                            !values.locationServices.some((k: any) => k.netRegionId.value === f.netRegionId)
                                                                        ).map((e) => {
                                                                            return {
                                                                                value: e.netRegionId,
                                                                                label: e.netRegionName,
                                                                            };
                                                                        })}
                                                                    />
                                                                    <div className="error">
                                                                        {!values.locationServices[index].netRegionId && values.locationServices[index].individualId && " This question is required."}
                                                                    </div>
                                                                </div>
                                                                <div className="flex flex-1 min-w-0 ml-2">
                                                                    <div className="flex-1 min-w-0">
                                                                        <AGSelect
                                                                            // isSearchable={false}
                                                                            placeholder="Choose contact(s)"
                                                                            value={values.locationServices[index].individualId}
                                                                            onChange={(f: any) => {
                                                                                if (Array.isArray(f) && f.length === 0) {
                                                                                    setFieldValue(
                                                                                        `locationServices.${index}.individualId`,
                                                                                        undefined,
                                                                                    );
                                                                                    return;
                                                                                }
                                                                                if (f.length > 3) {

                                                                                    setFieldValue(
                                                                                        `locationServices.${index}.individualId`,
                                                                                        f.slice(
                                                                                            1,
                                                                                            4,
                                                                                        ),
                                                                                    );
                                                                                } else {
                                                                                    setFieldValue(
                                                                                        `locationServices.${index}.individualId`,
                                                                                        f,
                                                                                    );
                                                                                }
                                                                            }}
                                                                            options={individual && individual?.sort((a, b) => ((a.firstName +
                                                                                " " + a.lastName) > (b.firstName + " " + b.lastName)) ? 1
                                                                                : ((b.firstName + " " +
                                                                                    b.lastName) > (a.firstName +
                                                                                        " " +
                                                                                        a.lastName) ? -1 : 0))
                                                                                .map(
                                                                                    (e) => {
                                                                                        return {
                                                                                            value: e.individualId,
                                                                                            label:
                                                                                                e.firstName +
                                                                                                " " +
                                                                                                e.lastName,
                                                                                        };
                                                                                    },
                                                                                )}
                                                                            isMulti
                                                                        />
                                                                        <div className="error">
                                                                            {!values.locationServices[index].individualId && values.locationServices[index].netRegionId && " This question is required."}
                                                                        </div>
                                                                    </div>
                                                                    <div className="flex-shrink-0 ml-2">
                                                                        <AGButton
                                                                        type="Primary"
                                                                        style={{
                                                                            borderRadius: 5,
                                                                            opacity: values.locationServices.length === 1 ? 1 : 1,
                                                                            border: "1px solid",
                                                                            color: "#2c76aa",
                                                                            borderColor: "#2c76aa",
                                                                            background: "transparent",
                                                                            width: "38px",
                                                                            height: "38px"
                                                                        }}
                                                                        disabled={values.locationServices.length === 0}
                                                                        onClick={() => {
                                                                            arrayHelpers.remove(index);
                                                                            ((values.locationServices.length > initialValues!.locationServices!.length) && isLocationServiceEqual) ? setIsDataChanged(false) : setIsDataChanged(dirty);
                                                                        }}>
                                                                        <MinusIcon />
                                                                    </AGButton>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            />

                                            <div className="w-full pb-[15px]">
                                                <label className="label-title">
                                                    Product Name:
                                                    <span className="required">
                                                        {" "}
                                                        *
                                                    </span>
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            A short name that clearly identifies your product and does not exceed 100 characters.
                                                        </i>
                                                    </span>
                                                </div>
                                                <AGInput
                                                    maxLength={100}
                                                    placeholder="Enter your answer"
                                                    className="custom-input"
                                                    value={values.title}
                                                    onChange={(e) => {
                                                        setFieldValue("title", e.target.value)
                                                    }}
                                                />
                                                {errors.title && (
                                                    <div className="error">
                                                        This question is
                                                        required.
                                                    </div>
                                                )}
                                            </div>
                                            {/* {Object.keys(errors).length >
                                                0 &&
                                                messengeError && (
                                                    <div className="error">
                                                        {
                                                            Object.keys(
                                                                errors,
                                                            ).length
                                                        }{" "}
                                                        question(s) need to
                                                        be completed:{" "}
                                                        {messengeError}
                                                    </div>
                                                )} */}
                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Specialized Product:{" "}
                                                    <span className="required">
                                                        *
                                                        <Tooltip text={<div className="tool-tip">
                                                            Select a specialized product area to feature.
                                                            Complete and submit another Commerce Product Profile for any additional specialized services you wish to feature.
                                                            If you would like to feature a specialized product area that is not listed,
                                                            please email <a
                                                                href={`mailto:${process.env.REACT_APP_CONTACT_SUPPORT_MAIL ||
                                                                    "techsupport@allinialglobal.com"
                                                                    }`}
                                                                className="linkified">
                                                                {process.env.REACT_APP_CONTACT_SUPPORT_MAIL ||
                                                                    "techsupport@allinialglobal.com"}
                                                            </a> to request it to be added.
                                                        </div>
                                                        } />
                                                    </span>
                                                </label>
                                                <div>
                                                    <AGSelect
                                                        isDisabled
                                                        placeholder="Enter/ Select Specialized Service"
                                                        value={values.mainServiceId}
                                                        onChange={(e: any) => {
                                                            setFieldValue("mainServiceId", e);
                                                            setFieldValue("compracticeLevels", [{
                                                                compracticeLevel: "",
                                                                secondaryServiceId: "",
                                                            }]);
                                                        }}
                                                        options={comMainService?.map(
                                                            (e) => {
                                                                return {
                                                                    value: e.mainServiceId,
                                                                    label: e.mainServiceName,
                                                                };
                                                            },
                                                        )}
                                                    />
                                                </div>
                                                {errors.mainServiceId && (
                                                    <div className="error">
                                                        This question is
                                                        required.
                                                    </div>
                                                )}
                                            </div>
                                            <FieldArray
                                                name="compracticeLevels"
                                                render={(arrayHelpers) => (
                                                    <div>
                                                        <label
                                                            style={{
                                                                width: "100%",
                                                                display: "flex",
                                                                justifyContent: "space-between",
                                                                alignItems: "start"
                                                            }}
                                                            className="label-title"
                                                            htmlFor="">
                                                            <div className="wraptitle">
                                                                Product Category:<span className="required">{" "}*
                                                                    <Tooltip text={
                                                                        <div className="tool-tip">
                                                                            Select the various product category your organization has within the specialized
                                                                            product area.
                                                                        </div>
                                                                    } />
                                                                </span>
                                                            </div>

                                                        </label>
                                                        <div data-tip="Tooltip content" className="subtitle flex">
                                                            Select at least 1 product category.
                                                            <Button
                                                                type="Link"
                                                                icon={<PlusIcon />}
                                                                onClick={() =>
                                                                    arrayHelpers.push(
                                                                        {
                                                                            compracticeLevel: "",
                                                                            secondaryServiceId: "",
                                                                        },
                                                                    )
                                                                }
                                                                disabled={optionInitialComSecondaryServices ? values.compracticeLevels.length >= optionInitialComSecondaryServices?.length : true}
                                                            >
                                                                <div className="add-new">Add new</div>
                                                            </Button>
                                                        </div>
                                                        {values.compracticeLevels.map((e: any, index: number,) => (
                                                            <div
                                                                className="form-item-custom"
                                                                key={index}>
                                                                <div className="custom-select">
                                                                    <AGSelect
                                                                        placeholder="Choose product category"
                                                                        value={values.compracticeLevels[index].secondaryServiceId}
                                                                        onChange={(f: any) => {
                                                                            setFieldValue(`compracticeLevels.${index}.secondaryServiceId`, f);
                                                                        }}
                                                                        options={tblComSecondaryServices}
                                                                    />
                                                                    {/* <div className="error">
                                                                        {!values.compracticeLevels[index].compracticeLevel &&
                                                                            values.compracticeLevels[index].secondaryServiceId &&
                                                                            " This question is required."}
                                                                    </div> */}
                                                                </div>
                                                                <div className="wraper-right">
                                                                    <AGButton
                                                                        type="Primary"
                                                                        style={{
                                                                            borderRadius: 5,
                                                                            opacity: values.compracticeLevels.length === 1 ? 0.2 : 1,
                                                                            border: "1px solid",
                                                                            color: "#2c76aa",
                                                                            borderColor: "#2c76aa",
                                                                            background: "transparent"
                                                                        }}
                                                                        disabled={values.compracticeLevels.length === 1}
                                                                        onClick={() => {
                                                                            arrayHelpers.remove(index);
                                                                            ((values.compracticeLevels.length > initialValues!.compracticeLevels!.length) && isExterpriseEqual) ? setIsDataChanged(false) : setIsDataChanged(dirty);
                                                                        }}>
                                                                        <MinusIcon />
                                                                    </AGButton>
                                                                </div>
                                                            </div>
                                                        ))}
                                                        {errors.compracticeLevels && (
                                                            <div className="error">
                                                                This question is
                                                                required.
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            />
                                            
                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Product Logo:
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            Please upload a product logo photo with a preferred size of 280x180px and should not exceed 0.5MB. Image file type must be .jpg,.jpeg,.png,.gif,.webp
                                                        </i>
                                                    </span>
                                                </div>

                                                <div className="wraper-removeButton">
                                                    {values.serviceLogo?.name && (
                                                        <AGButton
                                                            onClick={() => {
                                                                setFieldValue(
                                                                    "isDeleteServiceLogo",
                                                                    !initialValues.serviceLogo.name ? false : true,
                                                                );
                                                                setFieldValue(
                                                                    "serviceLogo",
                                                                    {name: undefined},
                                                                );
                                                            }}
                                                            type="Secondary">
                                                            Remove Logo
                                                        </AGButton>
                                                    )}
                                                    <label className="lable-upload">
                                                        <input
                                                            id="upload-photo"
                                                            name="serviceLogo"
                                                            accept="image/*"
                                                            type="file"
                                                            style={{
                                                                display: "none",
                                                            }}
                                                            key={values.serviceLogo}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    "serviceLogo",
                                                                    e
                                                                        .currentTarget
                                                                        .files?.[0]
                                                                        ? e
                                                                            .currentTarget
                                                                            .files[0]
                                                                        : "",
                                                                );
                                                                setFieldValue(
                                                                    "isDeleteServiceLogo",
                                                                    false,
                                                                );
                                                            }}
                                                        />

                                                        {!values.serviceLogo
                                                            ?.name && (
                                                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                                <a
                                                                    style={{
                                                                        color: "#2C76AA",
                                                                        textDecoration: "underline",
                                                                    }}>
                                                                    + Upload logo
                                                                </a>
                                                            )}

                                                        <span className="upload-name">
                                                            {
                                                                values.serviceLogo
                                                                    ?.name
                                                            }
                                                        </span>
                                                    </label>
                                                </div>
                                                {errors.serviceLogo && (<div className="error">
                                                    {errors.serviceLogo.toString()}
                                                </div>
                                                )}
                                            </div>
                                            <div className="w-full pb-[15px]">
                                                <label className="label-title">
                                                    Product Tag Line:
                                                    <span className="required">
                                                        {" "}
                                                        *
                                                    </span>
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            A brief phrase that creates a lasting impression about your product. </i>
                                                    </span>
                                                </div>
                                                <AGInput
                                                    maxLength={150}
                                                    placeholder="Enter your answer"
                                                    className="custom-input"
                                                    value={values.tagLine}
                                                    onChange={(e) => {
                                                        setFieldValue("tagLine", e.target.value)
                                                    }}
                                                />
                                                {errors.tagLine && (
                                                    <div className="error">
                                                        This question is
                                                        required.
                                                    </div>
                                                )}
                                            </div>
                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Video Link:
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            <span>
                                                                If the organization has a relevant marketing video, provide the URL/ YouTube.
                                                            </span>
                                                        </i>
                                                    </span>
                                                </div>
                                                <AGInput
                                                    maxLength={255}
                                                    placeholder="Enter Video URL"
                                                    className="custom-input"
                                                    value={values.videoLink}
                                                    onChange={(e) => {
                                                        setFieldValue("videoLink", e.target.value !== "" ? e.target.value : null)
                                                    }}
                                                />
                                                {errors.videoLink && (
                                                    <div className="error">
                                                        Please enter a valid
                                                        URL.
                                                    </div>
                                                )}
                                            </div>
                                            <div>
                                                <label className="label-title">
                                                    Product Detailed Description:{" "}
                                                    <span className="required">
                                                        *
                                                        <Tooltip text={<div className="tool-tip">Up to 2000 characters concisely describing the product line and distinct product category for this submission. Showcase important points about your organization in an intriguing way. Give recent project and client success examples that substantiate expertise and experience.</div>} />
                                                    </span>
                                                </label>
                                                <AGtextarea
                                                    maxLength={2000}
                                                    value={values.detailedDescription}
                                                    placeholder="Enter your answer"
                                                    className="text-area"
                                                    onChange={(e) => {
                                                        setFieldValue("detailedDescription", e.target.value)
                                                    }}
                                                />
                                                {errors.detailedDescription && (
                                                    <div className="error">
                                                        This question is
                                                        required.
                                                    </div>
                                                )}
                                            </div>
                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Product URL:
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            Please provide a URL to the organization’s webpage where the specialized product
                                                            and distinct product category are further described.
                                                        </i>
                                                    </span>
                                                </div>
                                                <AGInput
                                                    maxLength={255}
                                                    value={values.urlLink}
                                                    placeholder="Enter your answer"
                                                    className="custom-input"
                                                    onChange={(e) => {
                                                        setFieldValue("urlLink", e.target.value)
                                                        if (!e.target.value?.trim()) {
                                                            setFieldValue("webpageDisplayName", "")
                                                        }
                                                    }}
                                                />
                                                {errors.urlLink && (
                                                    <div className="error">
                                                        Please enter a valid
                                                        URL.
                                                    </div>
                                                )}
                                            </div>
                                            <div style={{ marginTop: 10 }}>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            If you prefer to display a name instead of the URL, please provide a display name for the organization's webpage.
                                                        </i>
                                                    </span>
                                                </div>
                                                <AGInput
                                                    value={values.webpageDisplayName}
                                                    placeholder="Enter your answer"
                                                    className="custom-input"
                                                    maxLength={254}
                                                    disabled={!values.urlLink?.trim()}
                                                    onChange={(e) => {
                                                        setFieldValue("webpageDisplayName", e.target.value)
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <label
                                                    className="label-title"
                                                    htmlFor="">
                                                    Brochure:
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            Upload an organization brochure (pdf file) featuring the specialized product area.
                                                        </i>
                                                    </span>
                                                </div>
                                                <div className="wraper-removeButton">
                                                    {values.filePdf?.name && (
                                                        <AGButton
                                                            onClick={() => {
                                                                setFieldValue(
                                                                    "isDeletePdf",
                                                                    !initialValues.filePdf.name ? false : true ,
                                                                );
                                                                setFieldValue(
                                                                    "filePdf",
                                                                    {name: undefined}
                                                                );
                                                            }}
                                                            type="Secondary">
                                                            Remove PDF
                                                        </AGButton>
                                                    )}
                                                    <label className="lable-upload">
                                                        <input
                                                            id="upload-photo"
                                                            name="filePdf"
                                                            accept="application/pdf"
                                                            type="file"
                                                            style={{
                                                                display: "none",
                                                            }}
                                                            key={values.filePdf}
                                                            onChange={(e) => {
                                                                setFieldValue(
                                                                    "filePdf",
                                                                    e
                                                                        .currentTarget
                                                                        .files?.[0]
                                                                        ? e
                                                                            .currentTarget
                                                                            .files[0]
                                                                        : "",
                                                                );
                                                                setFieldValue(
                                                                    "isDeletePdf",
                                                                    false,
                                                                );
                                                            }}
                                                        />

                                                        {!values.filePdf
                                                            ?.name && (
                                                                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                                                <a
                                                                    style={{
                                                                        color: "#2C76AA",
                                                                        textDecoration: "underline",
                                                                    }}>
                                                                    + Upload Document
                                                                </a>
                                                            )}
                                                        <span className="upload-name">
                                                            {
                                                                values.filePdf
                                                                    ?.name
                                                            }
                                                        </span>
                                                    </label>
                                                </div>
                                                {errors.filePdf
                                                    ?.toString()
                                                    .includes("_") ? (
                                                    <div className="error">
                                                        Please select file size
                                                        less than{" "}
                                                        {+(
                                                            process.env
                                                                .REACT_APP_PDF_SIZE_LIMIT ||
                                                            4194304
                                                        ) / 1048576}
                                                        MB.
                                                    </div>
                                                ) : errors.filePdf
                                                    ?.toString()
                                                    .includes("+") ? (
                                                    <div className="error">
                                                        Please select PDF file.
                                                    </div>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                            <div >
                                                <label className="label-title">
                                                    Member Benefits: <Tooltip text={<div className="tool-tip">Describe the specific benefits member organizations will receive (e.g. Discounts and other offerings).</div>} />
                                                </label>
                                                <div className="subtitle">
                                                    <span>
                                                        <i>
                                                            One or two simple sentences that are compelling and distill the member benefits within the specialized product area.
                                                        </i>
                                                    </span>
                                                </div>
                                                <AGTextarea
                                                    maxLength={255}
                                                    placeholder="Enter your answer"
                                                    className="text-area"
                                                    value={values.memberBenefits}
                                                    onChange={(e) => {
                                                        setFieldValue("memberBenefits", e.target.value)
                                                    }}
                                                />
                                            </div>
                                            <RolesHandleAdmin firmId={ADMIN_ORGANIZATION.ID} fkOrgId={ADMIN_ORGANIZATION.ID} roles={["Admin"]}>
                                                <label style={{ paddingTop: 10, marginBottom: 10, display: "flex", gap: 10, alignItems: "center" }} className="flex items-center">
                                                    <AGCheckbox
                                                        className="custom-checkbox"
                                                        classNameCus="custom-checkbox-sponsorProfile"
                                                        value={values.sponsorProfile}
                                                        onChange={(e) => {
                                                            setFieldValue("sponsorProfile", !values.sponsorProfile)
                                                        }}
                                                    />
                                                    <div>
                                                        <span style={{ padding: 0 }} className="label-title">
                                                            Sponsor Profile
                                                        </span>
                                                    </div>
                                                </label>
                                                {values.sponsorProfile && (
                                                    <div style={{
                                                        borderRadius: "7px",
                                                        padding: "0px 10px",
                                                        border: "1px solid rgb(223, 228, 234)",
                                                        marginBottom: 10
                                                    }}>
                                                        <div>
                                                            <div className="flex w-full gap-[15px]">
                                                                <div className="w-1/2">
                                                                    <label className="label-title-cus">
                                                                        Start Date: <span className="required">*</span>
                                                                    </label>
                                                                    <AddIconDatePicker>
                                                                        <GlobalStyle/>
                                                                        <StyledDatePickerCus
                                                                            isClearable
                                                                            className="react-datepicker-wrapper"
                                                                            selected={values.startDate}
                                                                            onChange={(date: any) => {
                                                                                setFieldValue("startDate", date);
                                                                                if (values.endDate && new Date(date) >= new Date(values.endDate)) {
                                                                                    setFieldValue("endDate", undefined);
                                                                                }
                                                                                setSelectedDate(date);
                                                                            }}
                                                                            placeholderText="mm/dd/yyyy"
                                                                            value={values.startDate}
                                                                            popperPlacement="top-start"
                                                                            onKeyDown={handleNumericDateInput}
                                                                        />
                                                                    </AddIconDatePicker>
                                                                    {errors.startDate && (
                                                                        <div className="error">
                                                                            This question is
                                                                            required.
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="w-1/2">
                                                                    <label className="label-title-cus">
                                                                        End Date: <span className="required">*</span>
                                                                    </label>
                                                                    <AddIconDatePicker>
                                                                        <StyledDatePickerCus
                                                                            isClearable
                                                                            className="react-datepicker-wrapper"
                                                                            selected={values.endDate}
                                                                            placeholderText="mm/dd/yyyy"
                                                                            onChange={(date: any) => {
                                                                                setFieldValue("endDate", date);
                                                                            }}
                                                                            value={values.endDate}
                                                                            popperPlacement="top-start"
                                                                            minDate={(selectedDate) ? moment(selectedDate).add(1, "day").toDate() :
                                                                                values.startDate ? moment(values.startDate).add(1, "day").toDate() :
                                                                                    !values.endDate ? undefined : moment(values.startDate).add(1, "day").toDate()}
                                                                            onKeyDown={handleNumericDateInput}
                                                                        />
                                                                    </AddIconDatePicker>
                                                                    {errors.endDate && (
                                                                        <div className="error">
                                                                            This question is
                                                                            required.
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="w-full pb-[15px]">
                                                                <label className="label-title">
                                                                    Sponsored Message: <span className="required">*</span>
                                                                </label>
                                                                <AGInput
                                                                    maxLength={50}
                                                                    placeholder="Enter your answer"
                                                                    className="custom-input"
                                                                    value={values.sponsorMessage}
                                                                    onChange={(e) => {
                                                                        setFieldValue("sponsorMessage", e.target.value)
                                                                    }}
                                                                />
                                                                {errors.sponsorMessage && (
                                                                    <div className="error">
                                                                        This question is
                                                                        required.
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </RolesHandleAdmin>
                                        </form >
                                    );
                                }}
                            </Formik >
                        </div >
                    </div >
                </CommerceCompassStyled >
            </CustomBackground >
        </AGModal >
    );
};
export default UpdateProductModal;


const PlusIcon = () => {
    return <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.0748 7.00797H10.3598V0.292969H7.63981V7.00797H0.924805V9.72797H7.63981V16.443H10.3598V9.72797H17.0748V7.00797Z" fill="#0971A2" />
    </svg>
}

const MinusIcon = () => {
    return <svg width={15} viewBox="0 0 24 24" fill="rgb(44, 118, 170)" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M6 12L18 12" stroke="rgb(44, 118, 170)" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg>
}